import { Rule } from '@travelnest/merlin.rule';
import * as React from 'react';
import { NavTile } from '../../components/nav-tile/NavTile';
import { Content } from '../../components/page';

export const NotFound: React.FC = () => {
	return (
		<>
			<Content>
				<h1>Uh-oh!</h1>
				<Rule />
				<h3>The page you are looking for cannot be found.</h3>
				<p>You can navigate back in your browser, or return to the dashboard below.</p>
				<NavTile
					label="Return to dashboard"
					to="/">
				</NavTile>
			</Content>

		</>
	);
};
